import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectEvent } from '@legacy-redux/preferences/selectors';
import { getSafetyQuestionAnswersForApproval } from '@legacy-services/api/safetyQuestions';

type Props = {
  event: any;
};

function DashboardWidgetSafetyQuestionAnswerApproval({ event }: Props) {
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await getSafetyQuestionAnswersForApproval(event.id);
      setAnswers(response.data);
    }

    if (event) {
      fetchData();
    }
  }, [event]);

  return (
    <div className="m-portlet m-portlet--full-height">
      <div className="m-portlet__head">
        <div className="m-portlet__head-caption">
          <div className="m-portlet__head-title">
            <span className="m-portlet__head-icon">
              <i className="flaticon-notes" />
            </span>
            <h3 className="m-portlet__head-text">Safety Question Answers Needing Approval</h3>
          </div>
        </div>
      </div>
      <div className="m-portlet__body">
        <table className="table m-table m-table">
          <tbody>
            {answers.map((answer: any) => (
              <tr key={answer.id}>
                <td>{answer.registration.company.name}</td>
                <td>
                  <Link
                    to={`/admin/safety-question-answers/review`}
                    className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
                  >
                    <span>
                      <i className="la la-eye" />
                      <span>Review</span>
                    </span>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  event: selectEvent(state),
});

export default connect(mapStateToProps)(DashboardWidgetSafetyQuestionAnswerApproval);
